// extracted by mini-css-extract-plugin
export default {"tooltip":"TooltopComponent_tooltip__vkKZC","checkboxSelection":"TooltopComponent_checkboxSelection__FmmkR"};